// extracted by mini-css-extract-plugin
export default {"header":"header_header__Xyv6g","header__title":"header_header__title__AFTgM"};